import {Badge} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/badge.types';
import {useFavoriteBrandStatusById, useIsProductInBasket} from '@aboutyou/user';
import {
  getBadgeNameList,
  getBrandIdAndProductId,
  useDisplayBadges,
} from './utils';

type useBadgesListParams = {
  badges: Badge[];
  sale: string | null;
  campaignSale: string | null;
  useDefaultLabels?: boolean;
  showPriceOverhaulV2SaleLabel: boolean;
  productInBasketFetcher?: (productID?: number) =>
    | boolean
    | {
        isFetched: boolean;
        isInBasket: boolean;
      };
};

export const useBadgesList = ({
  badges,
  sale,
  campaignSale,
  useDefaultLabels,
  showPriceOverhaulV2SaleLabel,
  productInBasketFetcher = useIsProductInBasket,
}: useBadgesListParams) => {
  const {brandId, productId} = getBrandIdAndProductId(badges);
  const personalizedBadge = useFavoriteBrandStatusById(brandId);
  const productInBasketFetcherResponse = productInBasketFetcher(productId);
  const isInBasket =
    typeof productInBasketFetcherResponse === 'boolean'
      ? productInBasketFetcherResponse
      : productInBasketFetcherResponse?.isInBasket ?? false;

  const badgesList = useDisplayBadges(badges, {
    isInBasket,
    personalized: personalizedBadge,
    campaignSale,
    sale,
    useDefaultLabels,
    showPriceOverhaulV2SaleLabel,
  });

  return badgesList;
};

export const useBadgesListKeys = ({
  badges,
  sale,
  campaignSale,
  useDefaultLabels,
  showPriceOverhaulV2SaleLabel,
}: useBadgesListParams) => {
  const badgesList = useBadgesList({
    badges,
    sale,
    campaignSale,
    useDefaultLabels,
    showPriceOverhaulV2SaleLabel,
  });
  return getBadgeNameList(badgesList);
};
